export default function protocoloGuard(store) {
  return (to, from, next) => {
    const getSearchProtocolo = () => {
      if (typeof window === "undefined") {
        return null;
      }
      const searchParams = new URLSearchParams(window.location.search);
      return searchParams.get("protocolo");
    };

    const urlProtocolo = to.query.protocolo || getSearchProtocolo();
    const currentProtocolo = store.state.context.protocolo;
    const isLocked = store.state.context.protocoloLocked;

    // Se há protocolo na URL e não está locked, salvar
    if (urlProtocolo && !isLocked) {
      store.dispatch('initProtocolo', urlProtocolo);
    }

    // Se está locked e a navegação não tem o protocolo, adicionar
    if (isLocked && currentProtocolo && to.query.protocolo !== currentProtocolo) {
      next({
        ...to,
        query: {
          ...to.query,
          protocolo: currentProtocolo
        }
      });
      return;
    }

    next();
  };
}
